<template>
    <div>
        <div class="mb-2">{{ props.question.text[participant.language] }}</div>
        <div v-for="answer in props.question.answers" :key="answer.value" class="ms-4 mb-4 form-check">
            <input 
                class="form-check-input" 
                type="radio" 
                :name="props.question.variable" 
                :id="props.question.variable +'_'+ answer.value"
                :value="answer.value"
                :checked="response[props.question.variable] == answer.value"
                @click="response[props.question.variable] = answer.value; saveResponse()"
            >
            <label 
                class="form-check-label" 
                :for="props.question.variable +'_'+ answer.value"
            >
                {{ answer.label[participant.language] }}
            </label>
        </div>
    </div>
</template>


<script setup>
    import { storeToRefs } from 'pinia'
    import { useSurveysStore } from '../../../stores/surveys'

    const { saveResponse } = useSurveysStore()
    const { participant, response } = storeToRefs(useSurveysStore())
    const props = defineProps(['question'])
</script>